import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LanguageContext } from "../../Languages/LanguageContext";
import NewPagination from "./Pagination/NewPagination";
import toast from "react-hot-toast";

import AddDeliveryPersonModal from "../Modals/AddDeliveryPersonModal";
import { fetchDeliveryPartner } from "../../../features/dashboard/newBuilderSlice";
import Loader from "../../../components/Loader";
import EditDeliveryPersonModal from "../Modals/EditDeliveryPersonModal";
import { editDeliveryPerson } from "../../../features/dashboard/newBuilderSlice";
import { updatePartnerStatus } from "../../../features/dashboard/newBuilderSlice";
import UpdatePersonStatusModal from "../Modals/UpdatePersonStatusModal";
const DeliveryPerson = () => {
  const dispatch = useDispatch();
  const { t } = useContext(LanguageContext);

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [selectedDelivery, setSelectedDelivery] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [updatingId, setUpdatingId] = useState(null);

  const { deliveryPartners, loading, error } = useSelector(
    (state) => state.dashboard || {},
  );

  useEffect(() => {
    dispatch(fetchDeliveryPartner({ page, limit }));
  }, [dispatch, page, limit]);

  const partners = deliveryPartners?.data || [];
  const pagination = deliveryPartners?.pagination || { total_pages: 1 };

  const handleReload = () => {
    dispatch(fetchDeliveryPartner({ page, limit }));
  };

  const handleAdd = (item) => {
    setShowAddModal(true);
  };

  const handleEditPerson = (item) => {
    setShowEditModal(true);
    setSelectedDelivery(item);
  };

  const handleUpdatePersonStatus = (item) => {
    setShowStatusModal(true);
    setSelectedDelivery(item);
  };

  const handleSave = (updatedData) => {
    if (!selectedDelivery) return;

    dispatch(
      editDeliveryPerson({ partner_id: selectedDelivery.id, ...updatedData }),
    )
      .unwrap()
      .then(() => {
        toast.success("Delivery person updated successfully!");
        setShowEditModal(false);
        dispatch(fetchDeliveryPartner({ page, limit }));
      })
      .catch((err) => {
        toast.error(err.message || "Failed to update delivery person");
      });
  };

  const handleUpdateStatus = (partnerId, is_active) => {
    const currentPartner = partners.find((p) => p.id === partnerId);

    if (currentPartner && currentPartner.is_active === is_active) {
      toast.error(
        `This partner is already ${is_active ? "Active" : "Inactive"}!`,
      );
      return;
    }

    setUpdatingId(partnerId);

    dispatch(updatePartnerStatus({ partner_id: partnerId, is_active }))
      .unwrap()
      .then(() => {
        toast.success(
          `Delivery person status updated to ${
            is_active ? "Active" : "Inactive"
          }!`,
        );

        setShowStatusModal(false);

        dispatch(fetchDeliveryPartner({ page: 1, limit: 10 }));
      })
      .catch((err) => {
        toast.error(err.message || "Failed to update partner status");
      })
      .finally(() => setUpdatingId(null));
  };

  return (
    <div className="container-fluid ">
      <div className="d-flex flex-sm-row flex-column justify-content-sm-between  mb-2">
        <h4 className="text-light fw-bold mb-3">{t.deliveryperson}</h4>
        <div className="d-flex gap-2 justify-content-end">
          <button
            className="btn   btn-success"
            style={{ height: "40px" }}
            onClick={handleAdd}
          >
            Add Person
          </button>
          <div
            className="btn btn-sm btn-light d-flex justify-content-center align-items-center text-white"
            style={{ cursor: "pointer", width: "35px", height: "35px" }}
            onClick={handleReload}
          >
            <i className="bi bi-arrow-clockwise fs-5"></i>
          </div>
        </div>
      </div>
      {loading && (
        <div className="text-center text-warning fw-bold">
          Loading delivery persons...
        </div>
      )}
      {error && (
        <div className="text-center text-danger fw-bold">Error: {error}</div>
      )}

      <div className="table-responsive">
        {loading ? (
          <Loader />
        ) : (
          <table className="table table-bordered table-hover align-middle text-center text-info">
            <thead className="table-light">
              <tr>
                <th className="text-info">Name</th>
                <th className="text-info">Username</th>
                <th className="text-info">Email</th>
                <th className="text-info">Phone</th>
                <th className="text-info">Status</th>
                <th className="text-info">Created At</th>

                <th className="text-info">Action</th>
              </tr>
            </thead>
            <tbody>
              {partners.length > 0 ? (
                partners.map((item) => (
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>{item.username}</td>
                    <td>{item.email}</td>
                    <td>{item.phone}</td>
                    <td>{item.is_active ? "Active" : "Inactive"}</td>
                    <td>{item.created_at}</td>

                    <td>
                      <div className="d-flex justify-content-center gap-2">
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleEditPerson(item)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleUpdatePersonStatus(item)}
                        >
                          Update status
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-muted text-center">
                    No deliveries found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {!loading && !error && (
        <NewPagination
          page={pagination.page || page}
          totalPages={pagination.total_pages || 1}
          setPage={setPage}
        />
      )}

      <UpdatePersonStatusModal
        show={showStatusModal}
        onClose={() => setShowStatusModal(false)}
        delivery={selectedDelivery}
        onSave={handleUpdateStatus}
      />
      <EditDeliveryPersonModal
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        delivery={selectedDelivery}
        onSave={handleSave}
      />
      <AddDeliveryPersonModal
        show={showAddModal}
        onClose={() => setShowAddModal(false)}
      />
    </div>
  );
};

export default DeliveryPerson;
